import { IAttrValue } from "@multiweb/types/contracts";
import { ITextBuilder } from "../../../../Global/Base/Builders/ITextBuilder";
import { ValidatableControl } from "../../../UI.BaseControls/ValidatableControl";
import { Column } from "../Columns/Column";
import { ICellContent } from "../Components/ICellContent";
import { TableCellContent } from "../Components/TableCellContent";
import { ITemplate } from "./ITemplate";

export class ItemTemplate implements ITemplate {
    private _column: Column;

    public get parentColumn(): Column {
        return this._column;
    }

    public set parentColumn(v: Column) {
        this._column = v;
    }

    public init(): void {
        // Prazdna metoda
    }

    /**
     * Základní renderovaci funkce, ktera se stara o zpracování HTML struktury elementu
     * @param column definice sloupce
     * @param data pole dat
     */
    public render(column: Column, dataSet: IAttrValue[]): ICellContent {
        this.parentColumn = column;

        const wrapper = this._createBasicElement(column);
        let contentElement = this._createContentElement();
        if (contentElement) {
            wrapper.appendChild(contentElement);
        } else {
            contentElement = wrapper;
        }

        this.updateData(dataSet, contentElement);

        return this._createCellContentContainer(wrapper, contentElement);
    }

    /**
     * Vytvoří hlavní element, do kterého se bude vkládat obsah jednotlivých buněk,
     * Pokud je null, tak se obsah vloží přímo do buňky tabulky
     */
    protected _createContentElement(): HTMLElement {
        return document.createElement("span");
    }

    /**
     * Vytvoří data, která jsou použita jako výsledek Render metody,
     * obsahují element určený k vložení do DOMu, element určený pro aktualizaci dat a element pro validaci
     * @param visualElement element určený k vložení do DOMu
     * @param dataElement element určený pro aktualizaci dat
     */
    protected _createCellContentContainer(visualElement: HTMLElement, dataElement: HTMLElement): ICellContent {
        return new TableCellContent(visualElement, dataElement, new ValidatableControl(visualElement, this.parentColumn.isEditable));
    }

    public async updateData(dataSet: IAttrValue[], item: HTMLElement): Promise<void> {
        const formatedData = await this._getJoinData(dataSet, this.parentColumn);
        item.textContent = formatedData;
        item.title = formatedData;
        item.dispatchEvent(new Event("updated"));
    }

    public updateDisplayedData(data: ITextBuilder, item: HTMLElement): void {
        item.textContent = data ? data.toString() : "";
    }

    /**
     * Vytvari základní html element pro vlozeni dat
     * @param column obsahuje definici sloupce
     */
    protected _createBasicElement(column: Column): HTMLTableDataCellElement {
        const item: HTMLTableDataCellElement = document.createElement("td");

        if (!column.withoutAttribute) {
            item.setAttribute("data-attrName", column.attrName);
            item.setAttribute("data-fullAttrName", column.fullAttrName);
        }

        if (column.width)
            item.width = column.width + "px";
        else
            item.width = "100%";

        item.setAttribute("data-id", column.id); // Se používá mimo jiné u sloupců bez atributu při změně jejich pořadí.

        return item;
    }

    /**
     * Vrati spojeny a naformatovany retezec dat, zavola formatovaci funkci ze sloupce
     * @param data pole dat
     * @param column Definice sloupce
     */
    protected async _getJoinData(data: IAttrValue[] | IAttrValue, column?: Column): Promise<string> {
        if (data == null)
            return "";

        if (data instanceof Array) {
            if (column && column.formatValue instanceof Function) {
                let r = "";
                let i = 0;
                for (const d of data) {
                    if (d instanceof Array) // pokud je 'd' pole AttrValues, tak by se vracela v 'r' hodnota jen pro první prvek pole, ale ta by nemusela odpovídat skutečné hodnotě buňky
                        return "";
                    if (i++ > 0)
                        r += " | ";
                    r += await column.formatValue(d);
                }
                return r;
            } else {
                return data.join(" | ");
            }
        } else {
            if (column && column.formatValue instanceof Function)
                return await column.formatValue(data);
            else
                return data.toString();
        }
    }

    protected _getDataFromSet(dataSet: IAttrValue[]): IAttrValue {
        return dataSet instanceof Array ? (dataSet.length > 0 ? dataSet[0] : null) : dataSet;
    }

    public dispose(): void {
        // Prazdna metoda
    }
}
